"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboButton = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("../Button");
const Menu_1 = require("../Menu");
const Stack_1 = require("../Stack");
const Icon_1 = require("../Icon");
const ComboButton = (_a) => {
    var { children, fillSpace, customStyles = {}, options, variant = 'primary' } = _a, props = __rest(_a, ["children", "fillSpace", "customStyles", "options", "variant"]);
    return (react_1.default.createElement(Stack_1.Stack, null,
        react_1.default.createElement(Menu_1.MenuStyles, null),
        react_1.default.createElement(Button_1.Button, Object.assign({ css: Object.assign({ borderTopRightRadius: 0, borderBottomRightRadius: 0, flex: fillSpace ? 1 : 'initial', position: 'relative', '&:focus': {
                    // Allow box-shadow to appear on the right side.
                    zIndex: 1,
                } }, customStyles), variant: variant, autoWidth: true }, props), children),
        options ? (react_1.default.createElement(Menu_1.Menu, null,
            react_1.default.createElement(Menu_1.Menu.Button, { css: {
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    height: 'auto',
                    '> *': {
                        transform: 'translateY(0)',
                        transition: 'transform .2s ease',
                    },
                    '&:hover > *, &[aria-expanded="true"] > *': {
                        transform: 'translateY(2px)',
                        transition: 'transform .2s ease',
                    },
                }, variant: variant },
                react_1.default.createElement(Icon_1.Icon, { size: 8, name: "chevronDown" })),
            react_1.default.createElement(Menu_1.Menu.List, null, options))) : null));
};
exports.ComboButton = ComboButton;
const ComboButtonItem = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return react_1.default.createElement(Menu_1.Menu.Item, Object.assign({}, props), children);
};
/**
 * Re-export the Menu components to make it easer
 * to use the ComboButton.
 */
ComboButton.Item = ComboButtonItem;
ComboButton.Divider = Menu_1.Menu.Divider;
